var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Banner'),_c('Feature'),_c('Security'),_c('Count'),_c('News'),_c('Contact'),_c('div',{attrs:{"id":"fb-root"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }